"use client";

import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { fetchMyPayments } from "../../../services/billingService";
import { extractApiErrorMessage } from "../../../utils/error-handler";
import { formatPaise, formatBillingDate } from "../../../utils/billingFormat";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";

const TenantPaymentHistory = ({ standalone = false, onBack } = {}) => {
  const navigate = useNavigate();
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    fetchMyPayments()
      .then((res) => {
        if (!res.data?.applicable) {
          if (!standalone) navigate("/dashboard", { replace: true });
          return;
        }
        setPayments(res.data?.payments || []);
      })
      .catch((err) => setError(extractApiErrorMessage(err)))
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <h1 className="text-2xl font-bold text-gray-900">Payment History</h1>
        <Button variant="outline" onClick={standalone ? onBack : () => navigate("/dashboard/billing")}>
          Back to Billing
        </Button>
      </div>

      {error && <div className="rounded-xl border border-red-200 bg-red-50 p-4 text-red-700 text-sm">{error}</div>}

      <div className="rounded-2xl border border-gray-100 bg-white shadow-sm overflow-x-auto">
        {loading ? (
          <div className="py-16 text-center text-gray-400 text-sm">Loading...</div>
        ) : payments.length === 0 ? (
          <div className="py-16 text-center text-gray-400 text-sm">No payments yet.</div>
        ) : (
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Amount</TableHead>
                <TableHead>Method</TableHead>
                <TableHead>Purpose</TableHead>
                <TableHead>Status</TableHead>
                <TableHead>Paid At</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {payments.map((p) => (
                <TableRow key={p._id}>
                  <TableCell>{formatPaise(p.totalAmount)}</TableCell>
                  <TableCell>{p.paymentMethod || "-"}</TableCell>
                  <TableCell>{p.purpose}</TableCell>
                  <TableCell>
                    <Badge variant={p.status === "SUCCESS" ? "default" : "secondary"}>{p.status}</Badge>
                  </TableCell>
                  <TableCell>{formatBillingDate(p.paidAt)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </div>
    </div>
  );
};

export default TenantPaymentHistory;
